export const HIDDEN_MESSAGE_METADATA_FIELD = 'hidden' as const;

export const INTERNAL_DATA_PART_TYPES = [
  'data-session-memory',
  'data-functional-commitments',
  'data-functional-artifacts',
  'data-gutenberg-pending-changes',
] as const;

export type InternalDataPartType = (typeof INTERNAL_DATA_PART_TYPES)[number];

export const VISIBLE_DATA_PART_TYPES = [
  'data-account-suspended',
  'data-agent-switch',
  'data-approval-applied',
  'data-approval-request',
  'data-balance-update',
  'data-brief-approved',
  'data-brief-editor',
  'data-brief-updated',
  'data-build-page-code-chunk',
  'data-build-page-progress',
  'data-build-page-reasoning-chunk',
  'data-build-progress',
  'data-continue-prompt',
  'data-conversation-title',
  'data-conversion-progress',
  'data-conversion-reasoning-chunk',
  'data-create-content-code-chunk',
  'data-create-content-progress',
  'data-contact-form-progress',
  'data-design-choice',
  'data-destructive-confirmation',
  'data-editing-session',
  'data-editor-warmup-status',
  'data-hard-stop',
  'data-hero-preview',
  'data-hero-preview-code-chunk',
  'data-hero-preview-gallery',
  'data-hero-preview-reasoning-chunk',
  'data-hero-selected',
  'data-punch-list',
  'data-hero-selection-reset',
  'data-input-placeholder',
  'data-insufficient-credits',
  'data-notification',
  'data-observation',
  'data-page-preview',
  'data-progress-display',
  'data-retry-status',
  'data-single-hero-preview',
  'data-site-analysis',
  'data-site-completion-plan',
  'data-site-plan-control',
  'data-site-code-chunk',
  'data-site-code-complete',
  'data-site-code-images',
  'data-site-code-theme-runtime',
  'data-site-file-change',
  'data-slug-assigned',
  'data-stream-error',
  'data-stream-interrupted',
  'data-task-execution',
  'data-task-lifecycle',
  'data-task-list',
  'data-task-status',
  'data-task-status-display',
  'data-token-limit-exceeded',
  'data-uploaded-files',
  'data-user-logo',
  'data-user-question',
] as const;

export type VisibleDataPartType = (typeof VISIBLE_DATA_PART_TYPES)[number];

const INTERNAL_DATA_PART_TYPE_SET = new Set<string>(INTERNAL_DATA_PART_TYPES);
const VISIBLE_DATA_PART_TYPE_SET = new Set<string>(VISIBLE_DATA_PART_TYPES);

export function isDataPartType(type: string): boolean {
  return type.startsWith('data-');
}

export function isInternalDataPartType(
  type: string,
): type is InternalDataPartType {
  return INTERNAL_DATA_PART_TYPE_SET.has(type);
}

export function isVisibleDataPartType(
  type: string,
): type is VisibleDataPartType {
  return VISIBLE_DATA_PART_TYPE_SET.has(type);
}
